module.exports = __webpack_public_path__ + "assets/img/图标／68px@2x(2).e6803acd.png";